import './section-events.component.scss';

import {Swiper, Pagination, Navigation, EffectFade} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

new Swiper('.section-events__slider .swiper', {
  modules: [Pagination, Navigation, EffectFade],
  slidesPerView: 1.4,
  spaceBetween: 8,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  breakpoints: {
    480: {
      slidesPerView: 1.8,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 1
    }
  }
});